import type { Mandate } from "@/types/mandate";

const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const BANK_CODES: Record<string, string> = {
  "HDFC Bank": "HDFC",
  "ICICI Bank": "ICIC",
  "State Bank of India": "SBIN",
  "Axis Bank": "UTIB",
  "Kotak Mahindra Bank": "KKBK",
  "Punjab National Bank": "PUNB",
};

export function bankCode(bankName: string): string {
  return BANK_CODES[bankName] ?? "ICIC";
}

export function resolveMandate(_refNo: string): Mandate | null {
  return null;
}

export function buildUmrn(m: Mandate): string {
  if (m.umrn) return m.umrn;
  return `${bankCode(m.bankName || "")}7000000012345678`;
}

export function fmtINR(n: number): string {
  return `\u20B9${Number(n || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatNow(): string {
  const d = new Date();
  let h = d.getHours();
  const mins = String(d.getMinutes()).padStart(2, "0");
  const ampm = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}, ${h}:${mins} ${ampm}`;
}